// extracted by mini-css-extract-plugin
export default {"BankInfo":"Bankinfo_BankInfo__p3dlV","bankAction":"Bankinfo_bankAction__SEDbb"};